import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import '../../styles/Archive.css';
import FilterForArchive from './FilterForArchive';
import TableForArchive from './TableForArchive';

import { clearArchive, initArchiveFilterParams, initArchiveFromServer } from '../../redux/actions/archive.action';
import useTranslations from '../../customHook/useTranslations';
import translations from '../../content/PagesContent/BrigadePages/brigadePageTranslations.json';
import { useFilterControl } from '../../customHook/useFilterControl';
import useInfiniteScroll from '../../customHook/useInfiniteScroll';
import HeaderForObject from '../CustomElements/HeaderForObject';

function Archive(props) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();

  // получение словаря для статических данных в зависимости от выбранного языка
  const t = useTranslations(translations);

  // Получаем параметры для фильтрации
  const { archiveFilterParams } = useSelector((state) => state.archive);

  // Начальное состояние для стейта фильтрации передаем пропсами
  const initialFormData = {
    brigadeId: '',
    deviceId: '',
    roadId: '',
    stationId: '',
    start: '',
    finish: '',
  };
  const [formData, setFormData] = useState(initialFormData);
    // состояние для строки поиска
  const [filterInput, setFilterInput] = useState('');

  // хук для сброса фильтров и флага для отображения кнопки сброса
  const { resetFilters, showBtnReset } = useFilterControl(initialFormData, formData, setFormData, '', setFilterInput);

  //сохраняем параметры фильтра чтобы при переходе на другие страницы они сохранились
  useEffect(() => {
    const hasPeriod = formData?.start && formData?.finish;
    if (!hasPeriod) {
      dispatch(clearArchive());
    }

    // при изменении форм даты обновляем состояние в редакса
    dispatch(initArchiveFilterParams(formData));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData]);

  //при открытии страницы обновляем фильтры из редакса если они там были
  useEffect(() => {
    setFormData(archiveFilterParams);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // хук для запроса данных с учетом параметров поиска фильтрации и сортировки, и контроля скрола
  const { bottomBoundaryRef,handleSearch, hasInitialRequest } = useInfiniteScroll(
    formData, // Данные фильтров
    '', // Строка поиска
    '', // Функция для изменения строки поиска
    initArchiveFromServer, // Функция для инициализации данных
    'archive', // Redux-селектор
    resetFilters, // Сброс фильтров
    clearArchive, // Очистка стейта
    false // Флаг для остановки запросов
  );

  return (
    <div className="archive">
      <FilterForArchive
        initialFormData={initialFormData}
        formData={formData}
        setFormData={setFormData}
        showBtnReset={showBtnReset}
        resetFilters={resetFilters}
        t={t}
      />
      <div className="documentation_content">
        <HeaderForObject
          searchInput={filterInput}
          onFilterChange={(e) => {
            setFilterInput(e?.target?.value);
          }}
          onFilterSubmit={handleSearch}
        />
        <TableForArchive
          t={t}
          hasInitialRequest={hasInitialRequest}
          bottomBoundaryRef={bottomBoundaryRef}
        />
      </div>
    </div>
  );
}

export default Archive;
